export default "__VITE_ASSET__8e32c531__"